import { ReactNode, useContext } from "react";
import cn from "classnames";
import { SubmitButton as CommonSubmitButton, SubmitButtonProps as CommonSubmitButtonProps } from "capitalrx-components-2.0/lib/forms";

import { ThemeSelectorContext } from "@/basic/context";

import styles from "../styles.module.scss";

export interface SubmitButtonProps extends CommonSubmitButtonProps {
  children: ReactNode;
}

export const SubmitButton = (props: SubmitButtonProps) => {
  const { children, ...rest } = props;
  const { client } = useContext(ThemeSelectorContext);

  const submitButtonClass = cn({ [styles["Button"]]: !!client });

  return (
    <CommonSubmitButton {...rest} className={submitButtonClass}>
      {children}
    </CommonSubmitButton>
  );
};
